module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/btn-stopp@2x.png?0.0.53";